import type { Messages } from "../types";

export const da = {
  "common": {
    "brand": "UN8",
    "brandTag": "Eksklusiv kristen dating",
    "continue": "Fortsæt",
    "leave": "Forlad",
    "leaveForNow": "Forlad for nu",
    "yes": "Ja",
    "no": "Nej",
    "goBack": "Gå tilbage",
    "saving": "Gemmer…",
    "submitting": "Sender…",
    "pleaseWait": "Vent venligst…",
    "ellipsis": "…",
    "male": "Mand",
    "female": "Kvinde",
    "phases": {
      "gate": "Port",
      "verify": "Verificér",
      "setup": "Opsætning",
      "profile": "Profil"
    },
    "storageQuota": "Denne telefon har ikke mere plads til gemte svar. Frigør lagerplads, og prøv igen.",
    "storageDisabled": "Denne browser gemmer ikke dine svar. Slå privat tilstand fra, eller tillad webstedsdata, og genindlæs.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min {min} tegn"
  },
  "welcome": {
    "promise": "Vores mål er, at du sletter denne app så hurtigt som muligt.",
    "sub": "UN8 hjælper seriøse kristne singler med at finde en livspartner — og derefter forlade. Verificeret. Værdier først. Ingen endeløs swiping.",
    "signedInAs": "Logget ind som {email}",
    "liveServer": " · live-server",
    "deviceOnly": " · kun denne enhed",
    "migrateOffer": "Denne enhed har stadig en lokal profil. Upload den til den delte server, så andre telefoner kan se dig efter moderation? Intet uploades, før du vælger.",
    "uploadLocalProfile": "Upload min lokale profil",
    "keepOnDevice": "Behold den kun på denne enhed",
    "migrateNeedGender": "Vælg først Mand eller Kvinde i din profil.",
    "migrateDone": "Profiltekst uploadet. Upload ID, video og fotos igen, så moderation kan gennemgå dem.",
    "deleteConfirm": "Slet permanent din konto, alle beskeder og al media (inkl. ID og video) fra serveren?",
    "accountDeleted": "Konto slettet.",
    "begin": "Begynd",
    "continueOnboarding": "Fortsæt onboarding",
    "logIn": "Log ind",
    "logOut": "Log ud",
    "reviewConsole": "Gennemgangskonsol",
    "matching": "Matching",
    "deleteMyAccount": "Slet min konto"
  },
  "faith": {
    "eyebrow": "Trosport",
    "title": "Kun kristne",
    "text": "UN8 er et fællesskab af efterfølgere af Jesus Kristus, for medlemmer der søger en ægteskabsorienteret partner, som deler den tro. Denne port kan ikke springes over.",
    "yesTitle": "Jeg er kristen",
    "yesBody": "Jeg følger Jesus Kristus og søger en ægteskabsorienteret partner, som deler denne tro.",
    "noTitle": "Jeg er ikke kristen",
    "noBody": "UN8 er ikke det rette sted for mig — og det er okay.",
    "respectTitle": "Med respekt",
    "respectBody": "UN8 er bygget til ét fællesskab, og vi vil hellere være ærlige end spilde din tid. Brug Forlad nedenfor, eller Tilbage, hvis dette ikke er dit hjem.",
    "sharedTitle": "Fælles fundament",
    "sharedBody": "Tro er ikke en etiket her. Det er jorden, I mødes på.",
    "hintNotChristian": "UN8 er for efterfølgere af Jesus Kristus. Tryk Forlad nedenfor, eller vælg den kristne mulighed, hvis det er dig.",
    "hintUnset": "Tryk „Jeg er kristen“ for at fortsætte, eller Forlad / Tilbage hvis dette ikke er dit hjem."
  },
  "rules": {
    "eyebrow": "Fællesskabets pagt",
    "title": "Hvordan vi behandler hinanden",
    "text": "Bekræft hver regel. Alle tre er påkrævet. Overtrædelser fører til permanent fjernelse. Falske profiler forbydes for evigt.",
    "agreeContinue": "Jeg accepterer — fortsæt",
    "respectful": {
      "title": "Vær respektfuld",
      "description": "Tal og handl med værdighed. Hvert menneske her er skabt i Guds billede."
    },
    "noSexualContent": {
      "title": "Intet seksuelt indhold",
      "description": "Ingen eksplicitte fotos, beskeder eller anmodninger. Renhed er ikke valgfrit her."
    },
    "noDominance": {
      "title": "Dominer eller kontrollér ikke",
      "description": "Ingen tvang, manipulation eller pres. Kærlighed kontrollerer ikke."
    },
    "hint": "Sæt kryds ved alle tre løfter, før du fortsætter."
  },
  "intent": {
    "eyebrow": "",
    "title": "Hvad leder du efter?",
    "text": "",
    "marriage": {
      "label": "En livspartner",
      "description": ""
    },
    "discernment": {
      "label": "Alvorlig skelnen",
      "description": ""
    },
    "notCasual": {
      "label": "Intet uforpligtende",
      "description": ""
    },
    "hint": "Vælg én."
  },
  "account": {
    "eyebrow": "Konto",
    "title": "Opret din adgang",
    "text": "Dit handle skaber et stabilt bruger-id. Ansøgning, verifikation, likes og matches binder alle til det id. Der sendes ingen e-mail.",
    "recoveryTitle": "Gem din gendannelseskode",
    "recoveryText": "Vises én gang. Uden den kan en mistet adgangsfrase ikke nulstilles i denne lukkede test.",
    "savedContinue": "Jeg har gemt den — fortsæt",
    "handle": "Handle",
    "handlePlaceholder": "dig@eksempel.com eller et kort handle",
    "passphrase": "Adgangsfrase",
    "passphrasePlaceholder": "Mindst 8 tegn",
    "signedInTitle": "Logget ind",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Tillidsstandard",
    "trustBody": "Ingen profil er synlig, før identitetsverifikation er fuldført, og moderation godkender dig.",
    "continueToVerification": "Fortsæt til verifikation",
    "hintEmail": "Skriv en e-mailadresse, der indeholder @.",
    "hintPassword": "Vælg en adgangskode på mindst 8 tegn."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verifikation",
      "title": "Tillid er porten",
      "text": "Upload et offentligt ID, en bekræftelsesvideo og {min}–{max} ægte fotos. Alt går ind i en gennemgangskø, før din profil kan vises.",
      "whyTitle": "Hvorfor vi verificerer",
      "whyBody": "Catfishing og halve sandheder har ingen plads her. Falske profiler forbydes permanent. Media gemmes med status pending_review, indtil den godkendes.",
      "start": "Start verifikation"
    },
    "steps": {
      "id": {
        "title": "Offentligt ID",
        "description": "Pas eller nationalt ID — kamera eller filupload."
      },
      "video": {
        "title": "Bekræftelsesvideo",
        "description": "En kort optagelse, der beviser, at du er til stede."
      },
      "photos": {
        "title": "Ægte fotos",
        "description": "Syv til ti tydelige fotos af dig selv."
      },
      "review": {
        "title": "Integritetsgennemgang",
        "description": "Uploads forbliver pending_review, indtil personalet bekræfter."
      }
    },
    "id": {
      "eyebrow": "Trin 1 af 4",
      "title": "Offentligt ID",
      "text": "Tag eller upload dit pas eller nationale ID. Intet postes offentligt — status forbliver pending_review, indtil personalet bekræfter.",
      "savedTitle": "ID gemt",
      "savedBody": "Næste er en kort bekræftelsesvideo af dit ansigt, derefter 7 til 10 ægte fotos af dig selv. Fortsæt låses op, når dette ID viser gemt.",
      "hint": "Tag eller upload et foto af dit offentlige ID, og vent til det står gemt."
    },
    "video": {
      "eyebrow": "Trin 2 af 4",
      "title": "Bekræftelsesvideo",
      "text": "Optag et kort klip eller upload et. Se ind i kameraet. Tal tydeligt. Dette beviser, at du er til stede — ikke et skrabt galleri.",
      "hint": "Optag en kort bekræftelsesvideo, og vent til det står gemt."
    },
    "photos": {
      "eyebrow": "Trin 3 af 4",
      "title": "Ægte fotos",
      "text": "Tilføj {min}–10 nyere fotos af dig selv. Brug kameraet eller dit bibliotek. Tryk × for at fjerne et billede.",
      "continueToReview": "Fortsæt til gennemgang",
      "hint": "Tilføj {min} til 10 tydelige fotos af dig selv. Fortsæt låses op, når de er gemt."
    },
    "review": {
      "eyebrow": "Trin 4 af 4",
      "title": "Integritetsgennemgang",
      "text": "Media er i kø som pending_review{underUser}. Matches og likes bruger samme id.",
      "underUser": " under bruger {userId}",
      "governmentId": "Offentligt ID",
      "confirmationVideo": "Bekræftelsesvideo",
      "photos": "Fotos",
      "missing": "Mangler",
      "filesReady": "{count} filer klar",
      "submittedTitle": "Sendt til gennemgang",
      "submittedText": "Ansøgnings-id er lig med auth-bruger-id, så godkend → pool og gensidige likes forbliver på linje.",
      "submitContinue": "Send & fortsæt"
    }
  },
  "setup": {
    "eyebrow": "Kontoopsætning",
    "title": "Fortæl sandheden om dig selv",
    "text": "Disse svar former matching og vises i gennemgang. Bløde løgne spilder alles tid — inklusive din.",
    "beginSetup": "Begynd opsætning",
    "pillars": {
      "faith": {
        "name": "Tro",
        "text": "Hvorfor du følger Kristus."
      },
      "character": {
        "name": "Karakter",
        "text": "Loyalitet, ærlighed, passion, engagement — bedømt 1–10."
      },
      "story": {
        "name": "Historie",
        "text": "Hvem du er, og hvad du søger."
      },
      "life": {
        "name": "Liv",
        "text": "Hobbyer, læsning og erhverv."
      }
    },
    "whyChristian": {
      "eyebrow": "Tro",
      "title": "Hvorfor er du kristen?",
      "text": "Et kort, ærligt svar. Ikke en prædiken — en grund, der er din.",
      "label": "Dit svar",
      "placeholder": "f.eks. Jeg mødte Kristus i en tid med tab og har fulgt Ham siden…",
      "hint": "Skriv mindst {min} tegn om, hvorfor du følger Jesus."
    }
  },
  "scales": {
    "eyebrow": "Karakterskalaer",
    "title": "Bedøm dig selv ærligt",
    "text": "Loyalitet, ærlighed, passion, engagement — hver fra 1 til 10. Oppustede tal mismatchet dig kun senere. Du skal sætte hver skala for at fortsætte.",
    "loyalty": {
      "label": "Niveau af loyalitet",
      "hint": "Vær ærlig — hvor trofast står du ved dem, du elsker?"
    },
    "honesty": {
      "label": "Niveau af ærlighed",
      "hint": "Hvor konsekvent fortæller du den fulde sandhed?"
    },
    "passion": {
      "label": "Hvor passioneret er du?",
      "hint": "Overbevisning og dybde — ikke optræden."
    },
    "commitment": {
      "label": "Niveau af engagement",
      "hint": "Hvor klar er du til at bygge noget, der varer?"
    },
    "hint": "Flyt hver skyder, så et tal vises — ingen må stå som en streg."
  },
  "about": {
    "eyebrow": "Om dig",
    "title": "Beskriv dig selv i nogle sætninger",
    "text": "Hvem du er, når ingen optræder. Temperament, rytme, hvad der betyder noget dag for dag.",
    "label": "Om dig",
    "placeholder": "Stille morgener, seriøs om familie, griner let, foretrækker dybde frem for støj…",
    "hint": "Skriv mindst {min} tegn om dig selv."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Hvad leder du efter?",
    "text": "Hovedkaraktertræk, du ønsker hos en potentiel partner — ikke en indkøbsliste over udseende.",
    "label": "Ønskede karaktertræk",
    "placeholder": "f.eks. Standhaftig tro, følelsesmæssig modenhed, venlighed under stress…",
    "hint": "Skriv mindst {min} tegn om den partner, du håber på."
  },
  "loveReady": {
    "eyebrow": "Tærskel",
    "title": "Er du klar til at møde dit livs kærlighed?",
    "text": "UN8 findes, så seriøse singler finder en partner — og derefter sletter appen. Kun „Ja“ låser fortsæt op.",
    "yesTitle": "Ja — jeg er klar",
    "yesBody": "Jeg er her for at møde min person med klarhed og mod.",
    "noTitle": "Ikke endnu",
    "noBody": "Hvis du kun bladrer, passer dette fællesskab ikke.",
    "comeBackTitle": "Kom tilbage, når du er klar",
    "comeBackBody": "UN8 er for folk, der er forberedt på at møde — ikke at samle muligheder. Brug Forlad nedenfor, hvis du vil stoppe for nu. Dine svar er gemt på denne telefon.",
    "hintNo": "Kun „Ja“ fortsætter. Hvis du ikke er klar, tryk Forlad for nu — dine svar bliver på denne telefon.",
    "hintUnset": "Tryk Ja, hvis du er klar til at møde nogen med ægteskab for øje."
  },
  "lifestyle": {
    "eyebrow": "Livsstil",
    "title": "Hvordan du lever dag for dag",
    "text": "Sport, hobbyer, læsning og erhverv — praktiske signaler for ægte kompatibilitet.",
    "hobbies": "Nuværende sport eller hobbyer",
    "hobbiesPlaceholder": "Det, du aktivt gør — ikke det, du engang gjorde.",
    "reading": "Læser du?",
    "readingHint": "1 = næsten aldrig · 10 = dagligt, dyb læsning",
    "profession": "Erhverv / sektor",
    "professionPlaceholder": "f.eks. Sygepleje · Software · Uddannelse · Håndværk",
    "hintHobbies": "Nævn mindst én sport eller hobby, du faktisk gør.",
    "hintReading": "Skyd „Læser du?“ så et tal fra 1 til 10 vises.",
    "hintProfession": "Skriv det arbejde, du laver, selv et kort ord."
  },
  "faithDepth": {
    "eyebrow": "Matching · Tro",
    "title": "Hvor central er din tro?",
    "text": "At tjene Gud — hvor vigtigt i dit liv? Svar ærligt. Matching bruger dette til dybde, ikke optræden.",
    "serving": "At tjene Gud — betydning",
    "servingHint": "10% … 100%. Skyd i trin af 10.",
    "keepsCommandments": "Holder du budene?",
    "grewUpInChurch": "Voksede du op i kirken?",
    "churchAttendance": "Kirkegang",
    "frequent": {
      "label": "Ofte",
      "hint": "Regelmæssig samling med Kristi legeme."
    },
    "seldom": {
      "label": "Sjældent",
      "hint": "Af og til, ikke en ugentlig rytme."
    },
    "never": {
      "label": "Aldrig",
      "hint": "Deltager ikke for tiden."
    },
    "spreadsGospel": "Spreder du evangeliet?",
    "hasIdols": "Har du afguder?",
    "hintServing": "Skyd, hvor vigtigt det er at tjene Gud i dit liv.",
    "hintCommandments": "Svar, om du holder budene — Ja eller Nej.",
    "hintGrewUp": "Svar, om du voksede op i kirken — Ja eller Nej.",
    "hintAttendance": "Vælg, hvor ofte du går i kirke.",
    "hintGospel": "Svar, om du deler evangeliet — Ja eller Nej.",
    "hintIdols": "Svar, om du har afguder — Ja eller Nej."
  },
  "character": {
    "eyebrow": "Matching · Karakter",
    "title": "Hvem du er hjemme",
    "text": "Karakter til frieri — fredsskabelse, manerer, ærlighed. Oppustede svar mismatchet dig kun senere.",
    "peacemaker": "Er du en fredsskaber?",
    "homebuilder": "Er du en hjemmebygger?",
    "humorous": "Er du humoristisk?",
    "caring": "Omsorgsfuld og kærlig?",
    "peacefulHome": "Vil du have et fredeligt hjem — fri for skænderier?",
    "manners": "Gode manerer?",
    "honestyRating": "Ærlighedsbedømmelse på dette spørgeskema",
    "honestyHint": "1–10 — hvor ærligt svarer du?",
    "hintPeacemaker": "Svar Ja eller Nej på hver, start med fredsskaber.",
    "hintHomebuilder": "Svar, om du er en hjemmebygger.",
    "hintHumorous": "Svar, om du er humoristisk.",
    "hintCaring": "Svar, om du er omsorgsfuld og kærlig.",
    "hintPeaceful": "Svar, om du vil have et fredeligt hjem.",
    "hintManners": "Svar, om du har gode manerer.",
    "hintHonesty": "Skyd din ærlighedsbedømmelse fra 1 til 10."
  },
  "history": {
    "eyebrow": "Matching · Historie",
    "title": "Fortid og beredskab",
    "text": "Stoffer, barndom, ar, og om du er klar til et varigt forhold. Sandhed her beskytter jer begge.",
    "marijuana": "Har du brugt marijuana?",
    "lsd": "Har du brugt LSD?",
    "otherDrugs": "Har du brugt andre stoffer?",
    "addicted": "Har du været afhængig?",
    "childhood": "Stabil, kærlig barndom?",
    "scars": "Ar / beskadiget?",
    "lasting": "Klar til et varigt forhold?",
    "hintStart": "Svar Ja eller Nej på hver på denne side, start øverst.",
    "hintLsd": "Svar på LSD-spørgsmålet — Ja eller Nej.",
    "hintOtherDrugs": "Svar, om du har brugt andre stoffer.",
    "hintAddicted": "Svar, om du har været afhængig.",
    "hintChildhood": "Svar, om din barndom var stabil og kærlig.",
    "hintScars": "Svar, om du bærer ar.",
    "hintLasting": "Svar, om du er klar til et varigt forhold."
  },
  "appearance": {
    "eyebrow": "Matching · Udseende",
    "title": "Tatoveringer",
    "text": "Dine tatoveringer, og om tatoveringer på en partner er acceptable for dig.",
    "hasTattoos": "Har du tatoveringer?",
    "acceptsPartner": "Acceptere tatoveringer på en partner?",
    "hintHas": "Sig, om du har tatoveringer — Ja eller Nej.",
    "hintAccepts": "Sig, om tatoveringer på en partner er acceptable for dig."
  },
  "home": {
    "eyebrow": "Matching · Hjem & land",
    "title": "Land, færdigheder, selvforsyning",
    "text": "Urter, dyrke mad, frugtskov, preppring, fællesjordbrug, konservering, overlevelse — og eventuelle særlige færdigheder.",
    "herbKnowledge": "Urteviden?",
    "plantOwn": "Dyrker du egen frugt og grøntsager?",
    "fruitForest": "Interesseret i en frugtskov?",
    "prepping": "Forbereder du dig til katastrofer?",
    "communityFarming": "Fællesjordbrug / uafhængigt liv?",
    "canning": "Syltning og konservering?",
    "survival": "Overlevelsesfærdigheder?",
    "specialSkills": "Særlige færdigheder (valgfrit)",
    "specialPlaceholder": "Alt andet, du bringer til en husstand eller land…",
    "hintStart": "Svar Ja eller Nej på hver om land og færdigheder, start øverst.",
    "hintPlant": "Svar, om du dyrker egen frugt og grøntsager.",
    "hintFruitForest": "Svar, om en frugtskov interesserer dig.",
    "hintPrepping": "Svar, om du forbereder dig til katastrofer.",
    "hintCommunity": "Svar, om fællesjordbrug interesserer dig.",
    "hintCanning": "Svar, om du sylter og konserverer mad.",
    "hintSurvival": "Svar, om du har overlevelsesfærdigheder."
  },
  "family": {
    "eyebrow": "Matching · Familie",
    "title": "Børn, trosdybde, stoffer",
    "text": "Hvad du har brug for hos en partner omkring trosintensitet, børn og tidligere stofbrug.",
    "children": "Børn",
    "wants": {
      "label": "Vil have børn",
      "hint": "At bygge en familie er en del af visionen."
    },
    "doesNotWant": {
      "label": "Vil ikke have børn",
      "hint": "Klar nej til børn."
    },
    "open": {
      "label": "Åben",
      "hint": "Skelner — ikke låst nogen vej."
    },
    "hasLivingWith": {
      "label": "Har børn — bor med dem",
      "hint": "Børn er allerede en del af dagliglivet."
    },
    "requiredFaith": "Minimum trosniveau, du har brug for hos en partner",
    "requiredFaithHint": "10% … 100%. Hård port, når begge sider har svaret.",
    "acceptsSubstances": "Acceptere tidligere stofbrug hos en partner?",
    "hintChildren": "Vælg ét kort om børn.",
    "hintFaith": "Skyd det minimum trosniveau, du håber på hos en partner.",
    "hintSubstances": "Sig, om tidligere stofbrug hos en partner er acceptabelt."
  },
  "ancestry": {
    "eyebrow": "Matching · Baggrund",
    "title": "Baggrundspræferencer",
    "text": "Del din baggrund og hvad du er åben for hos en partner. Dette former kun rangering — det skjuler aldrig nogen fra decket.",
    "yourBackground": "Din baggrund (vælg alle, der gælder)",
    "openToPartner": "Åben for hos en partner",
    "codeDesc": "Kode: {code}",
    "anyDesc": "Stærkeste præference for bredde — anbefales ved usikkerhed.",
    "preferenceOnly": "Kun præference — ikke en port.",
    "hintOwn": "Sæt kryds ved mindst én baggrund, der beskriver dig. Dette hjælper kun rangering — det skjuler aldrig nogen.",
    "hintAccepted": "Sæt kryds ved, hvad du er åben for hos en partner, eller „Åben — ingen præference“."
  },
  "interests": {
    "eyebrow": "Matching · Interesser",
    "title": "Det, du nyder",
    "text": "Vælg mindst én. Overlap hjælper rangering; stilhed straffes aldrig.",
    "hint": "Sæt kryds ved mindst én interesse."
  },
  "reflection": {
    "eyebrow": "Matching · Reflektion",
    "title": "Med egne ord",
    "text": "Disse fire svar vises i fuld længde og scores aldrig. Skriv det, der er sandt.",
    "describeYourself": "Beskriv dig selv",
    "lifePurpose": "Livsformål",
    "fifteenYear": "Dig og dit livs kærlighed om 15 år",
    "weaknesses": "Svagheder",
    "hintDescribe": "Beskriv dig selv med mindst {min} tegn.",
    "hintPurpose": "Skriv dit livsformål med mindst {min} tegn.",
    "hintVision": "Skriv 15-årsvisionen med mindst {min} tegn.",
    "hintWeaknesses": "Nævn en svaghed med mindst {min} tegn."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Nogle essentials",
    "text": "Hold det enkelt. Køn er binært her — mand eller kvinde — for klar matching.",
    "firstName": "Fornavn",
    "firstNamePlaceholder": "Som du ønsker at blive kendt",
    "age": "Alder",
    "agePlaceholder": "18+",
    "city": "By",
    "cityPlaceholder": "Hvor du er baseret",
    "sex": "Køn",
    "maleBody": "Jeg er en mand.",
    "femaleBody": "Jeg er en kvinde.",
    "hintName": "Skriv dit fornavn (mindst to bogstaver).",
    "hintAge": "Alder skal være 18 eller ældre.",
    "hintCity": "Skriv byen, hvor du bor.",
    "hintGender": "Vælg Mand eller Kvinde, så matching kan fungere."
  },
  "ready": {
    "title": "Du må træde ind.",
    "textNamed": "{name}, din verifikation og opsætning er registreret. Media er pending_review. Velkommen til UN8 — find din person, slet derefter appen.",
    "text": "Din verifikation og opsætning er registreret. Media er pending_review. Velkommen til UN8 — find din person, slet derefter appen.",
    "summaryAria": "Opsætningssammendrag",
    "christianRules": "Kristen · regler bekræftet",
    "mediaLine": "ID · video · {photoCount} fotos · kø {pending}",
    "scalesLine": "Skalaer L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Køn —",
    "professionFallback": "erhverv",
    "userLine": "Bruger {userId}",
    "enterMatching": "Gå til matching",
    "needGender": "Gå tilbage til profiltrinnet og vælg Mand eller Kvinde, prøv derefter igen."
  },
  "match": {
    "brandTag": "Matching",
    "navOnboarding": "Onboarding",
    "navReview": "Gennemgang",
    "navMatching": "Matching",
    "logOut": "Log ud",
    "enterTitle": "Gå til matching",
    "enterText": "Log ind med samme e-mail som fra onboarding. Ansøgning, pool, likes og matches bruger alle dit stabile bruger-id.",
    "email": "E-mail",
    "emailPlaceholder": "dig@eksempel.com",
    "password": "Adgangskode",
    "passwordPlaceholder": "Din adgangskode",
    "logIn": "Log ind",
    "guestOr": "Eller prøv en gæstesession (stabilt id pr. browser · kun demo)",
    "guestMan": "Gæst som mand",
    "guestWoman": "Gæst som kvinde",
    "goOnboarding": "Gå til onboarding →",
    "guestSession": "Gæstesession · demopool",
    "packTitle": "Dine fire",
    "packSkip": "Tryk for at fortsætte",
    "newSelection": "Nyt udvalg",
    "backToFour": "← Tilbage til dine fire",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "mand",
    "woman": "kvinde",
    "navSelection": "Udvalg",
    "navMessages": "Beskeder",
    "navProfile": "Profil",
    "tabToday": "Udvalg",
    "tabMatches": "Matches ({count})",
    "yourMatches": "Dine matches",
    "matchesSub": "Vedvarende gensidig interesse · {count} udgående {likesWord}",
    "like": "like",
    "likes": "likes",
    "emptyMatches": "Endnu ingen gensidig interesse. Fortsæt med at skelne ugens udvalg.",
    "valuesScore": "Værdier {score}",
    "chatOpen": " · Chat åben",
    "tapToChat": " · Tryk for at chatte",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Værdier {score}",
    "noProfileYet": "Ingen profil endnu",
    "noProfileText": "Afslut onboarding, eller tryk Onboarding øverst og derefter Begynd. Gæstematching er på startskærmen, hvis du kun vil kigge.",
    "matchingPaused": "Matching pauset",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Ingen at vise endnu",
    "todaysSetDone": "Det er ugens udvalg",
    "weeklyTitle": "Dine 4 denne uge",
    "weeklyTitleCount": "Dine {count} denne uge",
    "weeklyCountdown": "Næste udvalg om {days} dage",
    "weeklyCountdownOne": "Næste udvalg om 1 dag",
    "weeklyCountdownSoon": "Næste udvalg snart",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Det er ugens udvalg",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Der er endnu ingen på listen denne uge. Puljen fyldes — åbn Udvalg igen om et øjeblik, eller kom tilbage når flere medlemmer er godkendt.",
    "emptyDone": "Du har gennemgået ugens udvalg. Kom tilbage ved næste åbning, eller nulstil bunken.",
    "likesMayNotStick": " Likes bliver måske ikke hængende.",
    "poolMeta": "Pool: {pool} · Matches: {matches} · Liket: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Nulstil deck",
    "backOnboarding": "Tilbage til onboarding",
    "feedEyebrowDemo": "Ugentligt udvalg · Demo",
    "feedEyebrowLive": "Ugentligt udvalg · Pulje ({source}, {count})",
    "feedTitle": "Skeln med omsorg",
    "left": "{count} tilbage",
    "pass": "Spring over",
    "interested": "Interesseret",
    "swipeHint": "Swipe eller brug knapperne. En match åbnes kun, når interessen er gensidig og gemt.",
    "celebrationEyebrow": "Gensidig interesse",
    "celebrationTitle": "I matchte",
    "celebrationText": "{self} og {other} viste begge interesse. Værdialignment: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Chat er låst op for denne match. Hold det respektfuldt — pagt over bekvemmelighed.",
    "openChat": "Åbn chat",
    "keepDiscerning": "Fortsæt med at skelne",
    "cardSeeking": "Søger",
    "cardHobbies": "Hobbyer",
    "affinity": "Affinitet",
    "valuesScoreLabel": "Værdiscore",
    "scoreStrong": "Stærk alignment",
    "scoreSolid": "Solid alignment",
    "scoreModerate": "Moderat alignment",
    "scoreDifferent": "Forskellige rytmer",
    "characterAxisFoot": "Karakteraksen inkluderer de fire søjler",
    "youThem": "Dig {self} · Dem {other}",
    "stampInterest": "Interesse",
    "stampPass": "Spring over",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Jeres værdiscores ligger tæt ({score} af 100).",
    "explainLegacyFuller": "En fyldigere „hvorfor“ vises, efter I begge har afsluttet matchingsspørgsmålene.",
    "explainFaith": "Jeres trosintensitet ligger tæt — I tager efterfølgelse af Jesus med lignende alvor.",
    "explainCharacter": "Hvordan I behandler folk hjemme stemmer — fred, manerer og omsorg.",
    "explainPurpose": "I bedømte jeres egen ærlighed lignende, et tegn på delt alvor.",
    "explainHome": "I deler interesse for land, dyrkning eller et selvforsynende hjem.",
    "explainAncestry": "I begge foretrækker lignende familiebaggrunde. Det er en præference, ikke et filter — ingen skjules for det.",
    "explainTemperament": "Jeres interesser og temperament overlapper.",
    "explainFallback": "Der er en mulig match på de svar, I begge udfyldte.",
    "explainOverall": "Samlet affinitet {score} af 100.",
    "affinityAxes": {
      "faith": "Trosintensitet",
      "character": "Karakter & opførsel",
      "purpose": "Livsformålsalignment",
      "home": "Hjem & selvforsyning",
      "ancestry": "Kulturel & baggrundsaffinitet",
      "temperament": "Temperamentspasform"
    },
    "scaleAxes": {
      "loyalty": "Loyalitet",
      "honesty": "Ærlighed",
      "passion": "Passion",
      "commitment": "Engagement"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat utilgængelig",
    "unavailableText": "Denne match mangler eller tilhører ikke din session.",
    "backToMatches": "Tilbage til matches",
    "backMatches": "← Matches",
    "valuesSubscriber": "Værdier {score} · Abonnent",
    "valuesTrial": "Værdier {score} · Prøveperiode",
    "valuesKept": "Værdier {score} · Match beholdt",
    "empty": "Sig hej med omsorg. På den delte backend synkroniseres beskeder til begge telefoner efter en gensidig match.",
    "placeholder": "Besked til {name}…",
    "ariaMessage": "Besked",
    "send": "Send"
  },
  "billing": {
    "paywallCopy": "Efter din gratis prøveperiode beholder du alle, du allerede har matcht med, og kan fortsætte med at chatte. For at se nye mennesker, abonnér.",
    "signInToMatch": "Log ind for at bruge matching.",
    "signInFirst": "Log ind først.",
    "subscriberUntil": "Abonnent · indtil {date}",
    "renewal": "fornyelse",
    "freeTrial": "Gratis prøveperiode · {days} dage (slutter {date})",
    "soon": "snart",
    "trialEnded": "Prøveperiode afsluttet · matches & chat forbliver åbne",
    "subscribe": "Abonnér · ${price}/md",
    "subscribeEarly": "Abonnér tidligt · ${price}/md",
    "activeNote": "Abonnement aktivt — du kan se nye mennesker igen.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Gem din gendannelseskode",
    "recoveryText": "Skriv dette ned nu. Det vises én gang. Hvis du mister din adgangsfrase, er denne kode den eneste måde at nulstille den i den lukkede test.",
    "savedContinue": "Jeg har gemt den — fortsæt",
    "welcomeBack": "Velkommen tilbage",
    "createAccount": "Opret din konto",
    "intro": "Handle og adgangsfrase. Der sendes ingen e-mail eller SMS. Dit id forbliver stabilt over onboarding, gennemgang og matching.",
    "tabLogin": "Log ind",
    "tabRegister": "Registrér",
    "handle": "Handle",
    "handlePlaceholder": "dig@eksempel.com eller et kort handle",
    "passphrase": "Adgangsfrase",
    "passphrasePlaceholder": "Mindst 8 tegn",
    "submitLogin": "Log ind",
    "submitRegister": "Opret konto",
    "backWelcome": "Tilbage til velkomst"
  },
  "options": {
    "origin": {
      "african": "Afrikansk",
      "european": "Europæisk",
      "asian": "Asiatisk",
      "latino": "Latino / Hispanic",
      "middleEastern": "Mellemøstlig",
      "indigenous": "Urfolk",
      "mixed": "Blandet",
      "other": "Andet",
      "dutch": "Hollandsk",
      "german": "Tysk",
      "any": "Åben — ingen præference"
    },
    "interest": {
      "prayer": "Bøn",
      "worship": "Tilbedelse",
      "reading": "Læsning",
      "hiking": "Vandring",
      "music": "Musik",
      "cooking": "Madlavning",
      "farming": "Landbrug / have",
      "sports": "Sport",
      "missions": "Mission",
      "family": "Familieliv",
      "crafts": "Håndværk",
      "outdoors": "Udendørs"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ja",
      "no": "Nej"
    },
    "id": {
      "titleEmpty": "Offentligt ID",
      "titleReady": "ID klar",
      "hintEmpty": "Pas eller nationalt ID. Tag et livefoto, eller vælg et billede/PDF. Alle fire hjørner synlige.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · gemt",
      "previewAlt": "Forhåndsvisning af offentligt ID",
      "pdfAria": "PDF-dokument valgt",
      "takePhoto": "Tag foto",
      "retake": "Tag igen",
      "chooseFile": "Vælg fil",
      "replaceFile": "Erstat fil",
      "remove": "Fjern",
      "uploading": "Uploader…",
      "cameraTitle": "Fotografer dit ID",
      "signIn": "Log ind, før du uploader ID.",
      "uploadFailed": "Upload mislykkedes. Prøv igen.",
      "badFile": "Kunne ikke bruge denne fil."
    },
    "video": {
      "titleEmpty": "Bekræftelsesvideo",
      "titleLive": "Kamera live",
      "titleReady": "Video klar",
      "hintEmpty": "Sig dit fornavn, og at du tilslutter dig UN8 ærligt. 5–15 sekunder.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Optag",
      "cameraUpload": "Kameraupload",
      "chooseFile": "Vælg fil",
      "startRecording": "Start optagelse",
      "cancel": "Annuller",
      "stopSave": "Stop & gem",
      "recordAgain": "Optag igen",
      "replaceFile": "Erstat fil",
      "remove": "Fjern",
      "unsupported": "Liveoptagelse er utilgængelig her. Brug kameraupload eller vælg en fil.",
      "permissionDenied": "Kameratilladelse nægtet. Du kan stadig uploade en kort videofil.",
      "signIn": "Log ind, før du uploader video.",
      "uploadFailed": "Upload mislykkedes. Prøv igen.",
      "saveFailed": "Kunne ikke gemme optagelsen.",
      "badVideo": "Kunne ikke bruge denne video."
    },
    "photos": {
      "count": "{count} / {max} fotos",
      "minimumMet": "Minimum opfyldt",
      "moreRequired": "{n} mere påkrævet",
      "listAria": "Verifikationsfotos",
      "photoAlt": "Foto {n}",
      "removeAria": "Fjern foto {n}",
      "camera": "Kamera",
      "takePhoto": "Tag foto",
      "chooseFiles": "Vælg filer",
      "uploading": "Uploader…",
      "hint": "Tag foto åbner livekameraet. Vælg filer er kun til gallerivalg. Tydelige ansigtsbilleder — ingen filtre, der skjuler identitet. Maks {max}.",
      "cameraTitle": "Tag et foto af dig selv",
      "signIn": "Log ind, før du uploader fotos.",
      "someFailed": "Nogle fotos blev ikke uploadet. Prøv de mislykkede igen.",
      "addFailed": "Kunne ikke tilføje fotos."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Luk",
      "capture": "Tag billede",
      "cancel": "Annuller",
      "hint": "Hold stabilt. Livekameraet forbliver åbent, indtil du tager billede.",
      "unavailable": "Kamera er ikke tilgængeligt i denne browser. Brug Vælg fil i stedet.",
      "permissionDenied": "Kameratilladelse nægtet eller utilgængelig. Brug Vælg fil i stedet.",
      "frameFailed": "Kunne ikke tage dette billede.",
      "saveFailed": "Kunne ikke gemme fotoet."
    },
    "uploadStatus": {
      "uploading": "uploader…",
      "failed": "upload mislykkedes",
      "savedLocally": "gemt lokalt",
      "uploaded": "uploadet",
      "stored": "gemt",
      "awaitingUpload": "Afventer upload",
      "localFallbackNote": "{error} Filen er gemt på denne enhed; prøv igen, når sign-endpointet er oppe."
    }
  },
  "language": {
    "label": "Sprog",
    "choose": "Vælg sprog"
  },
  "shell": {
    "back": "Tilbage",
    "goBackAria": "Gå tilbage"
  }
} as Messages;
